module.exports = __webpack_public_path__ + "static/media/mahdi.3af9b70d.jpg";